import type { ContractDates } from '@urbanx/agx.activities.client';
import { AgxSpacer, AgxTable, AgxTypography, toDateMediumString } from '@urbanx/agx.ui-components2';

interface TaskProgressorContractDatesProps {
  contractDates?: ContractDates;
}

const TaskProgressorContractDates = ({ contractDates }: TaskProgressorContractDatesProps) => {
  if (!contractDates) {
    throw new Error('Task Progressor contract details did not include contract dates');
  }

  const dates = [
    { id: 'contract-date', label: 'Contract date', value: contractDates.contractDateSigned },
    {
      id: 'initial-deposit-date',
      label: 'Initial deposit date',
      value: contractDates.initialDepositDate,
    },
    {
      id: 'balance-deposit-date',
      label: 'Balance deposit date',
      value: contractDates.balanceDepositDate,
    },
    {
      id: 'cooling-off-expiry',
      label: 'Cooling-off expiry',
      value: contractDates.coolingOffExpiry,
    },
    {
      id: 'finance-due-date',
      label: 'Finance due date',
      value: contractDates.subjectToFinanceDue,
    },
    {
      id: 'building-and-pest-due-date',
      label: 'Building and pest due date',
      value: contractDates.buildingAndPestDue,
    },
    {
      id: 'body-corporate-records-due-date',
      label: 'Body corporate records due date',
      value: contractDates.inspectionOfBodyCorporateRecordsDue,
    },
    {
      id: 'expected-unconditional-date',
      label: 'Expected unconditional date',
      value: contractDates.expectedUnconditional,
    },
    { id: 'settlement-date', label: 'Settlement date', value: contractDates.settlementDate },
  ];

  return (
    <AgxSpacer gap="spacing-md" fill padding={{ bottom: 'spacing-xl' }}>
      <AgxTypography id="task-progressor-contract-dates-label" type="label" size="medium">
        Contract dates
      </AgxTypography>
      <AgxTable
        variant="minimal"
        tableStyle="square"
        columns={[{ name: 'Date Name', shrink: true }, 'Value']}
        rows={dates.map((date) => ({
          dataTestId: `task-progressor-${date.id}-row`,
          noHover: true,
          'Date Name': (
            <AgxTypography id={`task-progressor-${date.id}-label`} type="body_ui" size="small">
              {date.label}
            </AgxTypography>
          ),
          Value: (
            <AgxTypography id={`task-progressor-${date.id}-value`} type="body" size="medium">
              {toDateMediumString(date.value) ?? 'Not set'}
            </AgxTypography>
          ),
        }))}
      />
    </AgxSpacer>
  );
};

export default TaskProgressorContractDates;
